<div class="lidoma-app-container">
    <app-header></app-header>
    <app-page-loader [targetRouterUrls]="getAvailableLoadingUrls()">
        <main>
            <router-outlet></router-outlet>
        </main>
    </app-page-loader>
</div>

<app-floating-support></app-floating-support>
<app-gdpr-panel></app-gdpr-panel>
